import React, { memo, useMemo, useState, useEffect } from 'react';
import { Stack, Typography, TextField, FormGroup, FormControlLabel, Checkbox, Box, Button, TableCell, IconButton, Popover, InputAdornment } from '@mui/material';
import { useFormikContext, getIn } from 'formik';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { ArrowDropDown, CheckCircle, KeyboardArrowLeft, KeyboardArrowRight, CalendarMonth as CalendarMonthIcon } from "@mui/icons-material";
import DeleteIcon from '../Images/delete.png';
import { Dropdown } from './PayrollDropdown';




export const getSelectDropdownUI = () => ({
    PaperProps: {
        sx: {
            maxHeight: 200,
            overflowY: "auto",

            "& .MuiMenuItem-root": {
                fontSize: 11,
                paddingLeft: "8px",
                paddingRight: "8px",
                borderBottom: "1px solid #0e0e0e",
            },

            "& .MuiMenuItem-root:last-child": {
                borderBottom: "none",
            },

            "& .Mui-selected": {
                backgroundColor: "#2f5d8a !important",
                color: "white",
            },

            "& .Mui-selected:hover": {
                backgroundColor: "#2f5d8a !important",
            },

            /* Scrollbar */
            "&::-webkit-scrollbar": {
                width: 4,
            },
            "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#bdbdbd",
                borderRadius: 10,
            },
            "&::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#9e9e9e",
            }
        }
    }
});

export const sharedCalendarSlotProps = {
    toolbar: {
        hidden: false,
        toolbarTitle: "",
        toolbarFormat: "YYYY ddd DD MMM",
        toolbarPlaceholder: dayjs().format("YYYY ddd DD MMM"),

        sx: {
            backgroundColor: "#3d5c7b",
            color: "white",

            minHeight: "26px !important",
            height: "26px",
            padding: "0 6px",

            /* layout control */
            "& .MuiPickersToolbar-content": {
                display: "flex",
                alignItems: "center",
                width: "auto",
            },

            "& .MuiTypography-root": {
                color: "white",
                fontSize: "11px",
                lineHeight: "26px",
                fontWeight: 400,
            },
        }
    },
    actionBar: {
        actions: ["clear", "today", "ok"],
        sx: {
            padding: "8px 12px",

            "& .MuiButton-root": {
                backgroundColor: "white",
                color: "#000",
                fontSize: "11px",
                minWidth: "70px",
                fontWeight: 400,

                "&:hover": {
                    backgroundColor: "#e0e0e0"
                }
            },

            /* left button */
            "& .MuiButton-root:first-of-type": {
                marginRight: "auto",
                fontSize: "12px",
            },

            /* center button */
            "& .MuiButton-root:nth-of-type(2)": {
                margin: "0 auto",
                fontSize: "12px",
                color: "#594AE2"
            },

            /* right button */
            "& .MuiButton-root:last-of-type": {
                fontSize: "12px",
                marginLeft: "auto"
            }
        }
    },
    popper: {
        sx: {
            "& .MuiPaper-root": {
                minWidth: "260px",
                width: "260px",
            },
            "& .MuiPickersCalendarHeader-root": {
                height: "auto",
                minHeight: "24px",
                padding: "0 8px",
                marginTop: "4px",
                marginBottom: "0px",
            },
            "& .MuiPickersLayout-root": {
                fontSize: "10px",
                minWidth: "260px",
            },
            "& .MuiPickersDay-root": {
                fontSize: "11px",
                width: "28px",
                height: "28px",
                margin: "0 3px",
                fontWeight: 400,
            },
            "& .MuiDayCalendar-weekDayLabel": {
                width: "32px",
                height: "24px",
                fontSize: "11px",
                fontWeight: 400,
                color: "#666",
                margin: "0 1px",
                textTransform: "none",
            },
            "& .MuiPickersCalendarHeader-label": {
                fontSize: "11px !important",
                fontWeight: "400 !important",
            },
            "& .MuiPickersYear-yearButton": {
                fontSize: "11px !important",
                height: "20px",
                padding: "2px 0",
                fontWeight: "400 !important",
                "&.Mui-selected": {
                    fontSize: "11px !important",
                    fontWeight: "500 !important",
                }
            },
            "& .MuiPickersMonth-root": {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                margin: "0 !important",
            },
            "& .MuiPickersMonth-monthButton, & .MuiMonthCalendar-button": {
                width: "100% !important",
                maxWidth: "68px",
                height: "26px !important",
                minHeight: "26px !important",
                fontSize: "11px !important",
                fontWeight: "400 !important",
                lineHeight: "26px",
                padding: "0 4px !important",
                margin: "0 auto !important",
                borderRadius: "4px",
                "&.Mui-selected": {
                    fontSize: "11px !important",
                    fontWeight: "500 !important",
                }
            },
            "& .MuiYearCalendar-button": {
                fontSize: "10px !important",
                height: "22px",
                minHeight: "22px",
                lineHeight: 1.2,
                padding: "0 6px",
                fontWeight: "400 !important",
            },
            "& .MuiYearCalendar-button.Mui-selected": {
                fontSize: "11px !important",
                fontWeight: "500 !important",
            },
            "& .MuiYearCalendar-root": {
                width: "100%",
                height: "190px",
                maxHeight: "190px",
                overflowY: "auto",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                "&::-webkit-scrollbar": {
                    display: "none",
                },
            },
            "& .MuiMonthCalendar-root": {
                width: "100%",
                display: "grid !important",
                gridTemplateColumns: "repeat(3, 1fr) !important",
                gridTemplateRows: "repeat(4, 1fr) !important",
                gap: "6px 8px",
                padding: "8px 12px !important",
                height: "190px",
                maxHeight: "190px",
                boxSizing: "border-box",
                justifyItems: "center",
                alignItems: "center",
                overflow: "hidden",
            },
            "& .MuiDateCalendar-root": {
                width: "260px",
                height: "230px",
            }
        }
    }
};

export const formatCalendarWeekday = (date) => dayjs(date).format("ddd").toUpperCase();

export const MonthNavigationHeader = memo(({ currentMonth, onMonthChange, disabled, disableFuture, view, onViewChange, views }) => {
    const isNextDisabled = disabled || (disableFuture && (
        view === "year"
            ? dayjs(currentMonth).add(1, "year").year() > dayjs().year()
            : view === "month"
                ? dayjs(currentMonth).add(1, "year").isAfter(dayjs(), "year")
                : dayjs(currentMonth).add(1, "month").isAfter(dayjs(), "month")
    ));

    const goPrevious = () => {
        if (view === "month" || view === "year") {
            onMonthChange?.(dayjs(currentMonth).subtract(1, "year"));
        } else {
            onMonthChange?.(dayjs(currentMonth).subtract(1, "month"));
        }
    };

    const goNext = () => {
        if (isNextDisabled) return;
        if (view === "month" || view === "year") {
            onMonthChange?.(dayjs(currentMonth).add(1, "year"));
        } else {
            onMonthChange?.(dayjs(currentMonth).add(1, "month"));
        }
    };

    const handleTitleClick = () => {
        if (disabled || !onViewChange) return;
        if (view === "day") {
            onViewChange("month");
        } else if (view === "month") {
            onViewChange("year");
        } else if (view === "year") {
            onViewChange("month");
        }
    };

    const titleText = useMemo(() => {
        const d = dayjs(currentMonth);
        if (view === "month" || view === "year") {
            return d.format("YYYY");
        }
        return d.format("MMMM YYYY");
    }, [currentMonth, view]);

    return (
        <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{
                padding: "4px 8px 0px 8px",
            }}
        >
            <IconButton size="small" onClick={goPrevious} disabled={disabled} sx={{ p: "2px" }}>
                <KeyboardArrowLeft sx={{ fontSize: 18 }} />
            </IconButton>

            <Stack
                direction="row"
                alignItems="center"
                spacing={0.5}
                onClick={handleTitleClick}
                sx={{
                    userSelect: "none",
                    cursor: disabled || !onViewChange ? "default" : "pointer",
                    padding: "2px 8px",
                    borderRadius: "4px",
                    "&:hover": {
                        backgroundColor: "#eaf5fc",
                    },
                }}
            >
                <Typography
                    sx={{
                        fontSize: "11px",
                        fontWeight: 400,
                        color: view === "day" ? "#2c3e50" : "#1976d2",
                    }}
                >
                    {titleText}
                </Typography>
                <ArrowDropDown
                    sx={{
                        fontSize: 16,
                        color: view === "day" ? "#666" : "#1976d2",
                        transform: view === "day" ? "rotate(0deg)" : view === "month" ? "rotate(90deg)" : "rotate(180deg)",
                        transition: "transform 0.15s ease",
                    }}
                />
            </Stack>

            <IconButton size="small" onClick={goNext} disabled={isNextDisabled} sx={{ p: "2px" }}>
                <KeyboardArrowRight sx={{ fontSize: 18 }} />
            </IconButton>
        </Stack>
    );
});



export const FieldRow = memo(({ heading, name, value, onChange, inputProps, onBlur, labelWidth = 150, ...props }) => {
    const { values, handleChange, errors, touched, handleBlur } = useFormikContext();
    const error = getIn(errors, name);
    const isTouched = getIn(touched, name);

    return (
        <Stack direction="row" alignItems="center" spacing={2}>
            <Typography fontSize={12} width={labelWidth} textAlign="left">
                {heading}
            </Typography>
            <TextField
                name={name}
                value={(value !== undefined ? value : getIn(values, name)) ?? ""}
                onChange={onChange || handleChange}
                onBlur={onBlur || handleBlur}
                error={!!error && isTouched}
                helperText={isTouched && error}
                variant="filled"
                sx={{
                    flex: 1,
                    maxWidth: 220,
                    backgroundColor: "white",
                    "& .MuiFilledInput-root": {
                        backgroundColor: "white",
                        paddingTop: "0px",
                        paddingBottom: "0px",
                        height: "25px",
                        display: "flex",
                        alignItems: "center",
                        "&:hover:not(.Mui-disabled)": { backgroundColor: "white" },
                        "&.Mui-focused": { backgroundColor: "white" },
                        "&.Mui-disabled": { backgroundColor: "#E0E0E0 !important" }
                    },
                    "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#000 !important",
                        color: "#000 !important",
                    },
                }}
                size="small"
                inputProps={{ style: { padding: "0px 10px", fontSize: "12px" }, ...inputProps }}
                {...props}
            />
        </Stack>
    )
});


export const parseToDayjs = (val) => {
    if (!val) return null;
    if (dayjs.isDayjs(val)) return val.isValid() ? val : null;
    if (val instanceof Date) {
        const d = dayjs(val);
        return d.isValid() ? d : null;
    }
    const str = String(val).trim();
    if (!str) return null;

    const cleanDigits = str.replace(/\D/g, "");
    if (cleanDigits.length === 8) {
        // If YYYY-MM-DD format (starts with 4-digit year e.g. 2025-08-03 or 2025/08/03)
        if (str.match(/^\d{4}[-/]\d{1,2}[-/]\d{1,2}$/)) {
            const d = dayjs(str, "YYYY-MM-DD");
            if (d.isValid()) return d;
        }
        // Standard user or formik input: MMDDYYYY (e.g. 01252003 or 01-25-2003 or 01/25/2003)
        const m = cleanDigits.slice(0, 2);
        const day = cleanDigits.slice(2, 4);
        const y = cleanDigits.slice(4, 8);
        const d = dayjs(`${m}-${day}-${y}`, "MM-DD-YYYY");
        if (d.isValid()) return d;
    }

    const d = dayjs(str);
    return d.isValid() ? d : null;
};

export const CustomDatePicker = memo(({ heading, name, value, setFieldValue, disabled, disableFuture, labelWidth = 150, width = 220, spacing = 2 }) => {
    const formikContext = useFormikContext();
    const errors = formikContext?.errors || {};
    const touched = formikContext?.touched || {};
    const setFieldTouched = formikContext?.setFieldTouched || (() => { });

    const error = getIn(errors, name);
    const isTouched = getIn(touched, name);

    const actualValue = value !== undefined ? value : (formikContext ? getIn(formikContext.values, name) : null);

    const formatToDisplay = (val) => {
        if (!val) return "";
        const d = parseToDayjs(val);
        return d && d.isValid() ? d.format("MM/DD/YYYY") : (typeof val === "string" ? val : "");
    };

    const [inputValue, setInputValue] = useState(() => formatToDisplay(actualValue));
    const [anchorEl, setAnchorEl] = useState(null);
    const isCalendarOpen = Boolean(anchorEl);

    const parsedCalendarDate = useMemo(() => {
        if (!inputValue) return null;
        return parseToDayjs(inputValue);
    }, [inputValue]);

    const [calendarDate, setCalendarDate] = useState(() => parsedCalendarDate || null);
    const [currentView, setCurrentView] = useState("day");
    const currentViewRef = React.useRef("day");

    useEffect(() => {
        const formatted = formatToDisplay(actualValue);
        setInputValue(formatted);
        const d = parseToDayjs(actualValue);
        setCalendarDate(d);
    }, [actualValue]);

    const handleInputChange = (e) => {
        const raw = e.target.value;

        const updateFn = setFieldValue || formikContext?.setFieldValue;

        if (!raw.trim()) {
            setInputValue("");
            if (updateFn) updateFn(name, null);
            return;
        }

        const cleanDigits = raw.replace(/\D/g, "");
        if (cleanDigits.length === 8 && (raw.includes("/") || raw.includes("-") || raw.length === 8)) {
            const parsed = parseToDayjs(raw);
            if (parsed && parsed.isValid()) {
                if (!disableFuture || !parsed.isAfter(dayjs(), "day")) {
                    const formattedDisplay = parsed.format("MM/DD/YYYY");
                    const formattedFormik = parsed.format("MM-DD-YYYY");
                    setInputValue(formattedDisplay);
                    setCalendarDate(parsed);
                    if (updateFn) updateFn(name, formattedFormik);
                    return;
                }
            }
        }

        setInputValue(raw);
    };

    const handleBlur = () => {
        setFieldTouched(name, true);
        const updateFn = setFieldValue || formikContext?.setFieldValue;

        if (!inputValue.trim()) {
            setInputValue("");
            if (updateFn) updateFn(name, null);
            return;
        }

        const parsed = parseToDayjs(inputValue);

        if (parsed && parsed.isValid()) {
            if (disableFuture && parsed.isAfter(dayjs(), "day")) {
                setInputValue(formatToDisplay(actualValue));
            } else {
                const formattedDisplay = parsed.format("MM/DD/YYYY");
                const formattedFormik = parsed.format("MM-DD-YYYY");
                setInputValue(formattedDisplay);
                setCalendarDate(parsed);
                if (updateFn) updateFn(name, formattedFormik);
            }
        } else {
            setInputValue(formatToDisplay(actualValue));
        }
    };

    const handleOpenCalendar = (event) => {
        if (disabled) return;
        setAnchorEl(event.currentTarget);
        currentViewRef.current = "day";
        setCurrentView("day");
        const initialDate = parsedCalendarDate && parsedCalendarDate.isValid() ? parsedCalendarDate : null;
        setCalendarDate(initialDate);
    };

    const handleCloseCalendar = () => {
        setAnchorEl(null);
        currentViewRef.current = "day";
        setCurrentView("day");
        setFieldTouched(name, true);
    };

    const handleDateChange = (newDate, selectionState) => {
        if (!newDate || !dayjs(newDate).isValid()) return;

        const activeView = currentViewRef.current;

        if (activeView === "year") {
            const base = (calendarDate && calendarDate.isValid()) ? calendarDate : dayjs();
            const updated = base.year(dayjs(newDate).year());
            setCalendarDate(updated);
            currentViewRef.current = "month";
            setCurrentView("month");
            return;
        }

        if (activeView === "month") {
            const base = (calendarDate && calendarDate.isValid()) ? calendarDate : dayjs();
            const updated = base.year(dayjs(newDate).year()).month(dayjs(newDate).month());
            setCalendarDate(updated);
            currentViewRef.current = "day";
            setCurrentView("day");
            return;
        }

        // Final day selection in day view
        if (disableFuture && dayjs(newDate).isAfter(dayjs(), "day")) {
            return;
        }

        setCalendarDate(newDate);
        const formattedDisplay = dayjs(newDate).format("MM/DD/YYYY");
        const formattedFormik = dayjs(newDate).format("MM-DD-YYYY");

        setInputValue(formattedDisplay);
        const updateFn = setFieldValue || formikContext?.setFieldValue;
        if (updateFn) updateFn(name, formattedFormik);

        handleCloseCalendar();
    };

    const handleClearDate = () => {
        setInputValue("");
        setCalendarDate(null);
        const updateFn = setFieldValue || formikContext?.setFieldValue;
        if (updateFn) updateFn(name, null);
        handleCloseCalendar();
    };

    const handleTodayDate = () => {
        const today = dayjs();
        setCalendarDate(today);
        setInputValue(today.format("MM/DD/YYYY"));
        const updateFn = setFieldValue || formikContext?.setFieldValue;
        if (updateFn) updateFn(name, today.format("MM-DD-YYYY"));
        handleCloseCalendar();
    };

    return (
        <Stack direction="row" alignItems="center" spacing={spacing}>
            {heading !== undefined && heading !== null && (
                <Typography fontSize={11} width={labelWidth} textAlign="left">
                    {heading}
                </Typography>
            )}

            <TextField
                name={name}
                placeholder="MM/DD/YYYY"
                value={inputValue}
                onChange={handleInputChange}
                onBlur={handleBlur}
                disabled={disabled}
                error={!!error && isTouched}
                size="small"
                inputProps={{
                    style: {
                        padding: "0 8px",
                        fontSize: "11px",
                        fontWeight: 500,
                        height: "25px",
                        lineHeight: "25px",
                        boxSizing: "border-box",
                    }
                }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end" sx={{ marginRight: "-2px" }}>
                            <IconButton
                                size="small"
                                disabled={disabled}
                                onClick={handleOpenCalendar}
                                tabIndex={-1}
                                sx={{
                                    padding: "2px",
                                    color: disabled ? "#999" : "#555",
                                    "&:hover": { color: "#000" }
                                }}
                            >
                                <CalendarMonthIcon sx={{ fontSize: "16px" }} />
                            </IconButton>
                        </InputAdornment>
                    ),
                    sx: {
                        height: "25px",
                        minHeight: "25px",
                        backgroundColor: disabled ? "#E0E0E0 !important" : "white !important",
                        borderRadius: "5px",
                        paddingRight: "4px",
                        border: !!error && isTouched
                            ? "1px solid #d32f2f !important"
                            : "1px solid #c4c4c4 !important",
                        "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                        },
                        "&:hover": {
                            border: !!error && isTouched
                                ? "1px solid #d32f2f !important"
                                : (disabled ? "1px solid #c4c4c4 !important" : "1px solid rgba(0, 0, 0, 0.87) !important"),
                        },
                        "&.Mui-focused, &:focus-within": {
                            border: !!error && isTouched
                                ? "1px solid #d32f2f !important"
                                : "1px solid #1976d2 !important",
                        },
                        "&.Mui-disabled": {
                            backgroundColor: "#E0E0E0 !important",
                            border: "1px solid #c4c4c4 !important",
                            borderRadius: "4px",
                            "& input": {
                                WebkitTextFillColor: "#000 !important",
                                color: "#000 !important"
                            }
                        }
                    }
                }}
                sx={{
                    flex: 1,
                    width: width,
                    maxWidth: width,
                    backgroundColor: disabled ? "#E0E0E0" : "white",
                }}
            />

            <Popover
                open={isCalendarOpen}
                anchorEl={anchorEl}
                onClose={handleCloseCalendar}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                PaperProps={{
                    sx: {
                        minWidth: "260px",
                        width: "260px",
                        boxShadow: "0px 4px 16px rgba(0,0,0,0.18)",
                        borderRadius: "4px",
                        overflow: "hidden",
                        backgroundColor: "#fff",
                        ...sharedCalendarSlotProps.popper.sx
                    }
                }}
            >
                {/* Top Toolbar Header */}
                <Box
                    sx={{
                        backgroundColor: "#3d5c7b",
                        color: "white",
                        minHeight: "26px",
                        height: "26px",
                        padding: "0 8px",
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        ...sharedCalendarSlotProps.toolbar?.sx
                    }}
                >
                    <Typography
                        onClick={() => {
                            currentViewRef.current = "year";
                            setCurrentView("year");
                        }}
                        sx={{
                            position: "absolute",
                            left: 8,
                            color: "white",
                            fontSize: "11px",
                            fontWeight: 400,
                            lineHeight: "26px",
                            cursor: "pointer",
                            "&:hover": { opacity: 0.85 }
                        }}
                    >
                        {(calendarDate && calendarDate.isValid() ? calendarDate : (parsedCalendarDate || dayjs())).format("YYYY")}
                    </Typography>
                    <Typography sx={{ color: "white", fontSize: "11px", fontWeight: 400, lineHeight: "26px", textAlign: "center" }}>
                        {(calendarDate && calendarDate.isValid() ? calendarDate : (parsedCalendarDate || dayjs())).format("ddd, DD MMM")}
                    </Typography>
                </Box>

                {/* Calendar View */}
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateCalendar
                        value={calendarDate && calendarDate.isValid() ? calendarDate : (parsedCalendarDate || null)}
                        onChange={handleDateChange}
                        onMonthChange={(newMonth) => {
                            setCalendarDate((prev) => {
                                const base = prev && prev.isValid() ? prev : dayjs();
                                return base.year(newMonth.year()).month(newMonth.month());
                            });
                        }}
                        disableFuture={disableFuture}
                        dayOfWeekFormatter={formatCalendarWeekday}
                        slots={{
                            calendarHeader: MonthNavigationHeader
                        }}
                        slotProps={{
                            calendarHeader: {
                                disableFuture: disableFuture
                            }
                        }}
                        view={currentView}
                        onViewChange={(newView) => {
                            currentViewRef.current = newView;
                            setCurrentView(newView);
                        }}
                        views={['year', 'month', 'day']}
                        referenceDate={calendarDate && calendarDate.isValid() ? calendarDate : (parsedCalendarDate || dayjs())}
                        sx={{
                            width: "260px",
                            height: "230px",
                            margin: 0,
                            ...sharedCalendarSlotProps.popper.sx["& .MuiDateCalendar-root"]
                        }}
                    />
                </LocalizationProvider>

                {/* Bottom Action Bar Buttons */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "6px 10px",
                        borderTop: "1px solid #e0e0e0",
                        backgroundColor: "white",
                        ...sharedCalendarSlotProps.actionBar?.sx
                    }}
                >
                    <Button
                        size="small"
                        onClick={handleClearDate}
                        sx={{
                            fontSize: "11px",
                            fontWeight: 400,
                            color: "#000",
                            textTransform: "capitalize",
                            minWidth: "50px",
                            padding: "2px 6px",
                            "&:hover": { backgroundColor: "#e0e0e0" }
                        }}
                    >
                        Clear
                    </Button>

                    <Button
                        size="small"
                        onClick={handleTodayDate}
                        sx={{
                            fontSize: "11px",
                            fontWeight: 400,
                            color: "#594AE2",
                            textTransform: "capitalize",
                            minWidth: "50px",
                            padding: "2px 6px",
                            "&:hover": { backgroundColor: "#e0e0e0" }
                        }}
                    >
                        Today
                    </Button>

                    <Button
                        size="small"
                        onClick={handleCloseCalendar}
                        sx={{
                            fontSize: "11px",
                            fontWeight: 400,
                            color: "#000",
                            textTransform: "capitalize",
                            minWidth: "50px",
                            padding: "2px 6px",
                            "&:hover": { backgroundColor: "#e0e0e0" }
                        }}
                    >
                        Ok
                    </Button>
                </Box>
            </Popover>
        </Stack>
    );
});




export const LabeledTextField = memo(({ label, name, required = false, inputProps, ...props }) => {
    const { values, handleChange, touched, errors } = useFormikContext();
    const fieldVal = getIn(values, name);
    const fieldTouched = getIn(touched, name);
    const fieldError = getIn(errors, name);

    return (
        <Box>
            <Typography color="text.secondary" fontSize={11} fontWeight="bold" mb={0.25}>
                {label} {required && <span style={{ color: "red" }}>*</span>}
            </Typography>

            <TextField
                name={name}
                value={fieldVal ?? ""}
                onChange={props.onChange || handleChange}
                variant="filled"
                size="small"
                inputProps={{
                    style: {
                        padding: "4px",
                        height: "25px",
                        lineHeight: "25px",
                        fontSize: "12px"
                    },
                    ...inputProps
                }}
                InputProps={{
                    sx: {
                        height: 25,
                        display: "flex",
                        alignItems: "center",
                    },
                }}
                error={fieldTouched && Boolean(fieldError)}
                helperText={fieldTouched && fieldError}
                sx={{
                    "& .MuiFilledInput-root": {
                        backgroundColor: "white",
                        paddingTop: 0,
                        paddingBottom: 0,
                        "&:hover": { backgroundColor: "white" },
                        "&.Mui-focused": { backgroundColor: "white" }
                    },
                    width: "100%",
                }}
                {...props}
            />
        </Box>
    );
});

export const CustomOptions = memo(({ name, label, width = "100%", onClick }) => {
    const { values, setFieldValue } = useFormikContext();
    const selected = getIn(values, name) === true;
    return (
        <Button
            size="small"
            variant="contained"
            endIcon={
                <CheckCircle style={{ color: selected ? "#00ba00" : "#d7d7d7" }} />
            }
            onClick={() => onClick ? onClick() : setFieldValue(name, !selected)}
            disableRipple
            disableElevation
            style={{
                fontWeight: 400,
                fontSize: 12,
                border: selected ? "0.1px solid #f6ffe6" : "0.1px solid #d7d7d7",
                backgroundColor: selected ? "#f6ffe6" : "#ffffff",
                color: "#333",
                borderRadius: 4,
                textTransform: "none",
                width,
                padding: "2px 2px 2px 10px",
                cursor: "pointer",
            }}
        >
            <span style={{ flexGrow: 1, textAlign: "left", overflow: "hidden" }}>
                {label}
            </span>
        </Button>
    );
});

export const HeaderCell = memo(({ title, width, align }) => (
    <TableCell
        sx={{
            backgroundColor: "#d7d7d7",
            borderRight: "1px solid white",
            whiteSpace: "nowrap",
            fontSize: 13,
            padding: "8px 12px",
            color: "#444",
            textAlign: align || (title === "Actions" ? "center" : "left"),
            width: width
        }}
    >
        {title}
    </TableCell>
));

export const ActionButtons = memo(({ id, onDelete }) => (
    <Stack direction="row" spacing={1} alignItems={"center"} justifyContent="center">
        <span title="Delete">

            <IconButton size="small" onClick={() => onDelete(id)}>
                <img
                    style={{ cursor: "pointer" }}
                    src={DeleteIcon}
                    alt="delete"
                    width={20}
                    height={20}
                />
            </IconButton>
        </span>
    </Stack>
));

export const CustomSelect = memo(({ heading, name, value, onChange, options, labelWidth = 150, disabled }) => {
    const { values } = useFormikContext();
    const fieldValue = value ?? getIn(values, name) ?? "";
    return (
        <Stack direction="row" alignItems="center" spacing={2} sx={{ width: '100%' }}>
            <Typography fontSize={12} width={labelWidth} textAlign="left">
                {heading}
            </Typography>

            <Box sx={{
                flex: 1,
                maxWidth: 220,
                borderRadius: "4px",
                backgroundColor: disabled ? "#E0E0E0" : "transparent"
            }}>
                <Dropdown
                    name={name}
                    value={options.find(o => o.value === fieldValue) || { label: "--Select--", value: "" }}
                    options={options}
                    onChange={(fieldName, newValue) => {
                        // Create a synthetic event object to match what the original Select's onChange expects
                        const event = { target: { name: fieldName, value: newValue?.value ?? "" } };
                        onChange(event);
                    }}
                    getOptionLabel={(option) => option.label}
                    isEqual={(option, value) => option.value === value.value}
                    disabled={disabled}
                    sx={{
                        "& .MuiFilledInput-root": { height: 25 },
                        "& .MuiFilledInput-input": { padding: "0 10px", fontSize: "0.7rem" },
                    }}
                />
            </Box>
        </Stack>
    );
});

// export const CustomAutocomplete = memo(
// ({ heading, name, value, onChange, options, labelWidth = 150 }) => {

//     const { values } = useFormikContext();
//     const fieldValue = getIn(values, name);

//     return (
//         <Stack direction="row" alignItems="center" spacing={2}>
//             <Typography fontSize={12} width={labelWidth} textAlign="left">
//                 {heading}
//             </Typography>

//             <Autocomplete
//                 options={options}
//                 value={options.find((opt) => opt.value === fieldValue) || null}
//                 getOptionLabel={(option) => option.label || ""}
//                 onChange={(event, newValue) => {
//                     onChange({
//                         target: {
//                             name,
//                             value: newValue ? newValue.value : "",
//                         },
//                         option: newValue,
//                     });
//                 }}
//                 isOptionEqualToValue={(option, value) =>
//                     option.value === value.value
//                 }
//                 ListboxProps={{
//         sx: getSelectDropdownUI()
//     }}

//                 renderOption={(props, option) => (
//                     <Box
//                         component="li"
//                         {...props}
//                         sx={{
//                             color: option.value === "ADD_NEW" ? "#d32f2f" : "inherit",
//                             fontWeight: option.value === "ADD_NEW" ? 400 : "inherit",
//                         }}
//                     >
//                         {option.label || ""}
//                     </Box>
//                 )}

//                 sx={{
//                     flex: 1,
//                     maxWidth: 220,
//                     backgroundColor: "white",
//                 }}

//                 renderInput={(params) => (
//                     <TextField
//                         {...params}
//                         name={name}
//                         variant="filled"
//                         size="small"
//                         sx={{
//                             backgroundColor: "white",
//                             height: "25px",
//                             "& .MuiInputBase-root": {
//                                 backgroundColor: "white",
//                                 paddingTop: "0px",
//                                 paddingBottom: "0px",
//                                 minHeight: "25px",
//                                 "&:hover": { backgroundColor: "white" },
//                                 "&.Mui-focused": { backgroundColor: "white" }
//                             },
//                             "& input": {
//                                 paddingTop: "0px",
//                                 paddingBottom: "0px",
//                                 height: "25px",
//                                 fontSize: "12px",
//                                 paddingLeft: "10px"
//                             },
//                         }}
//                     />
//                 )}
//             />
//         </Stack>
//     );
// });

export const CustomCheckboxGroup = memo(({ heading, fields, setFieldValue }) => {
    return (
        <Stack spacing={1} alignSelf={"center"}>
            <FormGroup row>
                {fields.map(({ name, label, value, onChange }) => (
                    <FormControlLabel
                        key={name}
                        control={
                            <Checkbox
                                size="small"
                                checked={value || false}
                                onChange={(e) => {
                                    if (onChange) onChange(e.target.checked);
                                    else setFieldValue(name, e.target.checked);
                                }}
                            />
                        }
                        label={label}
                        sx={{ "& .MuiFormControlLabel-label": { fontSize: 12 } }}
                    />
                ))}
            </FormGroup>
        </Stack>
    );
});
